import styled from "styled-components";

export const FindAccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
